
export default function Values() {
  const values = [
    {
      icon: 'ri-flag-line',
      title: 'Mission First',
      description: 'We approach every client engagement with a mission mindset—prioritizing security, reliability, and results that protect operations and sensitive data.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Integrity in Everything',
      description: 'We operate with honesty, transparency, and accountability. Our clients trust us with critical systems, and we honor that trust in every decision we make.'
    },
    {
      icon: 'ri-service-line',
      title: 'Service Before Self',
      description: 'Inspired by military service, we are committed to supporting the defense community and small businesses with dedication, responsiveness, and respect.'
    },
    {
      icon: 'ri-lock-line',
      title: 'Security by Design',
      description: 'Security is not an add-on—it is the foundation of everything we deploy, configure, and support. Every solution is built to reduce risk and protect the mission.'
    },
    {
      icon: 'ri-award-line',
      title: 'Discipline and Excellence',
      description: 'We apply structured processes, proven frameworks, and continuous improvement to deliver consistent, high-quality results.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Knowledge and Innovation',
      description: 'We believe in constant learning and staying ahead of emerging threats and technologies, so our clients always benefit from modern, effective solutions.'
    },
    {
      icon: 'ri-team-line',
      title: 'Partnership and Trust',
      description: 'We build long-term relationships with our clients, acting as a trusted advisor and extension of their team—not just a vendor.'
    }
  ];

  return (
    <section className="py-24 px-8 bg-gray-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-[#0066CC]/10 rounded-full text-[#0066CC] text-sm font-semibold mb-6">
            Our Core Values
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Patriot Defense Technologies – Core Values
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-14 h-14 rounded-xl bg-[#0066CC]/10 flex items-center justify-center mb-6">
                <i className={`${value.icon} text-2xl text-[#0066CC]`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed text-sm">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
